import React from 'react';
import PropTypes from 'prop-types';

import { sanitize, render } from '../../lib/helpers';

const Safe = (props) => {
  const htmlProps = {
    ...props,
  };

  delete (htmlProps.render);
  delete (htmlProps.path);
  delete (htmlProps.value);
  delete (htmlProps.safe);

  if (props.render) {
    if (props.type === 'div') {
      return <div {...htmlProps} dangerouslySetInnerHTML={render({ ...props })} />; /* eslint-disable-line */
    }
    if (props.type === 'span') {
      return <span {...htmlProps} dangerouslySetInnerHTML={render({ ...props })} />; /* eslint-disable-line */
    }
  } else {
    if (props.type === 'div') {
      return <div {...htmlProps} dangerouslySetInnerHTML={sanitize(props.text, { html: true, safe: props.safe })} />; /* eslint-disable-line */
    }
    if (props.type === 'span') {
      return <span {...htmlProps} dangerouslySetInnerHTML={sanitize(props.text, { html: true, safe: props.safe })} />; /* eslint-disable-line */
    }
  }
};

Safe.propTypes = {
  render: PropTypes.bool,
  safe: PropTypes.bool,
  type: PropTypes.string,
  text: PropTypes.string,
};

Safe.defaultProps = {
  render: false,
  safe: false,
  type: 'span',
  text: '',
};

export default Safe;
